export default __webpack_public_path__ + "static/media/Alert_Icon_red.4563a9b7.svg";